<script lang="ts" setup>
import { proximityScoreMap } from '@thecompaniesapi/shared/client'

const props = defineProps({
  score: {
    default: 0,
    type: Number,
  },
})

const { t } = useI18n()

const scoringColor = computed(() => {
  if (!props.score) {
    return 'gray'
  }

  if (props.score >= proximityScoreMap.close) {
    return 'red'
  }

  if (props.score >= proximityScoreMap.near && props.score < proximityScoreMap.close) {
    return 'yellow'
  }

  return 'blue'
})

const scoringLabel = computed(() => {
  if (!props.score) {
    return t('undefined')
  }

  if (props.score >= proximityScoreMap.near && props.score < proximityScoreMap.close) {
    return t('near')
  }

  if (props.score >= proximityScoreMap.close) {
    return t('close')
  }

  return t('far')
})
</script>

<template>
  <div class="flex select-none items-center gap-2 text-sm">
    <BaseCircle
      class="size-4.5"
      :color="scoringColor"
    />

    {{ scoringLabel }}

    <span v-if="typeof score === 'number'">
      ({{ score }})
    </span>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "close": "Close",
    "far": "Far",
    "near": "Near",
    "undefined": "Undefined"
  },
  "es": {
    "close": "Cerca",
    "far": "Lejos",
    "near": "Cerca",
    "undefined": "Indefinido"
  },
  "fr": {
    "close": "Proche",
    "far": "Éloigné",
    "near": "Moyen",
    "undefined": "Indéfini"
  }
}
</i18n>
